'use strict';

// LP FAQ アコーディオンの開閉アニメーション。
// ネイティブ<details>は瞬時に開閉するため、Web Animations APIで高さをアニメーションさせる。
// プログレッシブエンハンスメント：JS/WAAPI未対応でもネイティブ挙動で開閉できる。
// prefers-reduced-motion 尊重（アニメーションなしで即時トグル）。
(function() {
  const DURATION = 240;
  const EASING = 'ease';

  function expand(details, content) {
    details.open = true;
    const endHeight = content.offsetHeight;
    content.animate(
      [
        { height: '0px', opacity: 0 },
        { height: endHeight + 'px', opacity: 1 }
      ],
      { duration: DURATION, easing: EASING }
    );
  }

  function collapse(details, content) {
    const startHeight = content.offsetHeight;
    const anim = content.animate(
      [
        { height: startHeight + 'px', opacity: 1 },
        { height: '0px', opacity: 0 }
      ],
      { duration: DURATION, easing: EASING }
    );
    // アニメーション完了後にネイティブのopen状態を閉じる。
    anim.onfinish = () => { details.open = false; };
  }

  function onSummaryClick(event) {
    const summary = event.currentTarget;
    const details = summary.parentElement;
    const content = details.querySelector('.lp-faq__a');
    if (!content || !details.animate) return;

    // ネイティブの即時トグルを抑止して、自前のアニメーションで開閉する。
    event.preventDefault();

    if (details.open) {
      collapse(details, content);
    } else {
      expand(details, content);
    }
  }

  function init() {
    const items = document.querySelectorAll('.lp-faq__item');
    if (items.length === 0) return;

    const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduce) return; // ネイティブの即時トグルに任せる

    items.forEach((details) => {
      const summary = details.querySelector('.lp-faq__q');
      if (summary) summary.addEventListener('click', onSummaryClick);
    });
  }

  document.addEventListener('turbolinks:load', init);
})();
